import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';

import { ClassifiedadComponent } from './classifiedad/classifiedad.component';

import { Adsummary1Component } from './adsummary1/adsummary1.component';
import { RegisterComponent } from './register/register.component';
import { Paymentmethod1Component } from './paymentmethod1/paymentmethod1.component';
import { ClassifieddisplayComponent } from './classifieddisplay/classifieddisplay.component';
import { Adsummary2Component } from './adsummary2/adsummary2.component';
import { Paymentmethod2Component } from './paymentmethod2/paymentmethod2.component';
import { DisplayadComponent } from './displayad/displayad.component';
import { Adsummary3Component } from './adsummary3/adsummary3.component';
import { Paymentmethod3Component } from './paymentmethod3/paymentmethod3.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { Adconfirmation1Component } from './adconfirmation1/adconfirmation1.component';
import { Datepicker1Component } from './datepicker1/datepicker1.component';
import { Datepicker2Component } from './datepicker2/datepicker2.component';
import { Datepicker3Component } from './datepicker3/datepicker3.component';
import { SearchBookingComponent } from './search-booking/search-booking.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ProfileComponent } from './profile/profile.component';
import { MyorderComponent} from './myorder/myorder.component';
import { VieworderComponent } from './vieworder/vieworder.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { OrderdetailsComponent } from './orderdetails/orderdetails.component';
import { CancelorderComponent } from './cancelorder/cancelorder.component';








const routes: Routes = [

  { path: 'home', component: HomeComponent },
  { path: 'profile', component: ProfileComponent },
   { path: 'term-condition', component: TermsConditionComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'cookie-policy', component: CookiePolicyComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'ad-order-id', component: SearchBookingComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'newpassword', component: NewPasswordComponent },
  { path: 'classifiedad', component: ClassifiedadComponent },
  { path: 'datepicker1', component: Datepicker1Component },
  { path: 'adsummary1', component: Adsummary1Component },
  { path: 'register', component: RegisterComponent },
  { path: 'paymentmethod1', component: Paymentmethod1Component },
  { path: 'classifieddisplay', component: ClassifieddisplayComponent },
  { path: 'datepicker2', component: Datepicker2Component },
  { path: 'adsummary2', component: Adsummary2Component },
  { path: 'paymentmethod2', component: Paymentmethod2Component },
  { path: 'displayad', component: DisplayadComponent },
  { path: 'datepicker3', component: Datepicker3Component },
  { path: 'adsummary3', component: Adsummary3Component },
  { path: 'paymentmethod3', component: Paymentmethod3Component },
  { path: 'adconfirmation1', component: Adconfirmation1Component },
  { path: 'new-password/:tokens', component: NewPasswordComponent },
  { path: 'verifyEmail/:tokens', component: VerifyEmailComponent },
  { path: 'orderdetails/:orderid', component: OrderdetailsComponent },
  { path: 'cancelorder/:orderid', component: CancelorderComponent },

  { path: 'myorder', component: MyorderComponent },
  { path: 'vieworder', component: VieworderComponent },
  { path: '**', redirectTo: 'home' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
